import { RouterStateSerializer } from '@myre/ui-domain-core';

export class RouterContextSerializer extends RouterStateSerializer {}
